import { CriteriaNumberRange } from '../../../../../../../../types/cmsProduct';
import { extractGiftRange } from '../../../../../../../../utils/helpers';
import { tr } from '../../../../../../../../utils/translations/tr';
import { OffersPlText } from '../../../../i18n';
import { TenureColumn } from './types';

const TENURE_COLUMNS = [12, 24, 36, 48, 60];

export const UNDER_12_COLUMN_KEY = 'under-12';

// Fixed 12–60 month columns. "Under 12 months" is added only when a gift's own
// tenure range starts below 12; it stands for the lowest such Min.
export const getTenureColumns = (
  tenureRanges: CriteriaNumberRange[],
  text: OffersPlText,
): TenureColumn[] => {
  const columns = TENURE_COLUMNS.map((tenure) => ({
    key: String(tenure),
    label: tr('tenure_months', text, { count: String(tenure) }),
    tenure,
  }));
  const under12Starts = tenureRanges
    .map((range) => extractGiftRange([range], 'ELIGIBLE_TENURE_RANGE').start)
    .filter((start): start is number => start !== null && start < 12);

  return under12Starts.length > 0
    ? [
        {
          key: UNDER_12_COLUMN_KEY,
          label: tr('under_12_months', text),
          tenure: Math.min(...under12Starts),
        },
        ...columns,
      ]
    : columns;
};
